// src/pages/plantation/monitor-setara-urea-per-umur/MenuStylesMonitorSetaraUrea.js
export const menuStyles = {
  paper: (paperShadow) => ({
    mt: 1,
    borderRadius: 2,
    boxShadow: paperShadow,
  }),
};